<style>
    :host {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
      font-size: 14px;
      color: #333;
      box-sizing: border-box;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
</style>
<p-confirmDialog 
    header="Atenção" 
    acceptLabel="Sim" 
    rejectLabel="Não"
    acceptButtonStyleClass="p-button-success"
    rejectButtonStyleClass="p-button-danger" 
    position="top"
    icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-toast [position]="this.toastUtilService.getPosition()" (onClose)="onClose()"></p-toast>
<router-outlet></router-outlet>